import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../models/tracer.model';

@Pipe({
  name: 'getMethodColor',
})
export class GetMethodColorPipe implements PipeTransform {
  transform(request: Request): string {
    const trace = request?.Traces?.find((t) => t.Source === 'requester');
    return trace ? '' : 'text-gray-400';
  }
}
